import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-challenges-report',
  templateUrl: './challenges-report.component.html',
  styleUrls: ['./challenges-report.component.scss']
})
export class ChallengesReportComponent implements OnInit {
  width = (window.innerWidth - 30)
  constructor() { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const width = event.target.innerWidth;
    this.width = (width - 30)
  }
  ngOnInit() {
  }

}
